import React from "react";
import { IMAGES } from "@/lib/content";
import { Flame, Heart, Leaf, Users, Star, Sparkles } from "lucide-react";
import { useSiteContent } from "@/lib/site-content";

const ICONS = {
  heart: Heart,
  leaf: Leaf,
  flame: Flame,
  users: Users,
  star: Star,
  sparkles: Sparkles,
};

export default function About() {
  const { content } = useSiteContent();
  const a = content.about || {};
  const rawParagraphs = Array.isArray(a.paragraphs)
    ? a.paragraphs.join("\n\n")
    : typeof a.paragraphs === "string"
      ? a.paragraphs
      : "";
  const paragraphs = rawParagraphs.split(/\n\s*\n/).filter(Boolean);

  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-20 md:py-32 bg-[#F5ECE1] relative overflow-hidden"
    >
      <div className="mx-auto max-w-[1400px] px-6 md:px-10 lg:px-16">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16 items-start">
          <div className="lg:col-span-5 lg:sticky lg:top-28">
            <div className="relative rounded-3xl overflow-hidden aspect-[4/5] lift">
              <img
                src={IMAGES.interior}
                alt="Cosy Thai restaurant interior"
                className="absolute inset-0 h-full w-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/55 via-transparent to-transparent" />
              <div className="absolute bottom-0 left-0 right-0 p-6 md:p-8 text-white">
                <div className="text-[10px] tracking-[0.3em] uppercase font-bold text-[#F5A623]">
                  The Space
                </div>
                <div className="mt-1 font-display font-black text-2xl md:text-3xl">
                  One plate. Thai street food.
                </div>
              </div>
            </div>
          </div>

          <div className="lg:col-span-7">
            <span className="chip" data-testid="about-chip">
              {a.chip}
            </span>
            <h2 className="mt-5 font-display font-black tracking-tighter text-4xl md:text-5xl lg:text-[64px] leading-[0.95]">
              {a.title_line1} <br />
              <span className="italic font-light">{a.title_line2_italic}</span>{" "}
              {a.title_line2_rest}
              <br />
              {a.title_line3}{" "}
              <span className="text-[#E53935]">{a.title_line3_red}</span>.
            </h2>
            <div className="mt-8 space-y-5 text-[17px] leading-relaxed text-[#1A1A1A]/85 max-w-xl">
              {paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 gap-5">
              {(a.pillars || []).map((p, i) => {
                const Icon = ICONS[p.icon] || Sparkles;
                return (
                  <div
                    key={i}
                    data-testid={`pillar-${(p.title || "").toLowerCase().replace(/\s/g, "-")}`}
                    className="rounded-2xl bg-white border border-[#E8DED5] p-6 lift"
                  >
                    <div className="h-11 w-11 rounded-full bg-[#E53935]/10 grid place-items-center text-[#E53935]">
                      <Icon className="h-5 w-5" />
                    </div>
                    <h4 className="mt-4 font-display font-bold text-lg">
                      {p.title}
                    </h4>
                    <p className="mt-2 text-sm text-[#5C534D] leading-relaxed">
                      {p.text}
                    </p>
                  </div>
                );
              })}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
